module.exports = __webpack_public_path__ + "img/bg.bb66ec2d.png";